import { cn } from '@/lib/utils'
import React from 'react'

interface GridBackgroundProps {
  children?: React.ReactNode
  className?: string
  showRadialGradient?: boolean
}

export function GridBackground({
  children,
  className,
  showRadialGradient = true
}: GridBackgroundProps) {
  return (
    <div className={cn('bg-background relative w-full', className)}>
      <div
        className={cn(
          'absolute inset-0',
          '[background-size:40px_40px]',
          '[background-image:linear-gradient(to_right,#e4e4e7_1px,transparent_1px),linear-gradient(to_bottom,#e4e4e7_1px,transparent_1px)]',
          'dark:[background-image:linear-gradient(to_right,#262626_1px,transparent_1px),linear-gradient(to_bottom,#262626_1px,transparent_1px)]'
        )}
      />
      {/* Radial gradient for the container to give a faded look */}
      {showRadialGradient && (
        <div className="bg-background pointer-events-none absolute inset-0 flex items-center justify-center [mask-image:radial-gradient(ellipse_at_center,transparent_20%,var(--background))]"></div>
      )}
      {children && <div className="relative z-20">{children}</div>}
    </div>
  )
}
